import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

/** Wraps a route that requires a logged-in user.
 *  For flows where new visitors are the norm (e.g. buying the £9.99 AI CV),
 *  pass `signupFirst` to send unauthenticated users to /register instead of
 *  /login. Both pages preserve the intended destination via `state.from`.
 */
export default function ProtectedRoute({ children, signupFirst = false }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        data-testid="auth-loading"
        className="min-h-screen flex items-center justify-center text-sm text-muted-foreground"
      >
        Loading your account...
      </div>
    );
  }

  if (!isAuthenticated) {
    const destination = signupFirst ? "/register" : "/login";
    return (
      <Navigate
        to={destination}
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return children;
}
